(function(){
  if(window.__v3BenefitsMotion)return;window.__v3BenefitsMotion=true;
  function setup(root){
    if(root.dataset.motionReady)return;root.dataset.motionReady='true';
    const items=Array.from(root.querySelectorAll('.v3-benefits__item'));
    const track=root.querySelector('.v3-benefits__list');
    const reduce=matchMedia('(prefers-reduced-motion: reduce)');
    const mobile=matchMedia('(max-width:749px)');
    let index=-1,timer=0,visible=false,paused=false,hover=false;
    function clear(){clearTimeout(timer);timer=0;}
    function step(){
      clear();if(!mobile.matches||!visible||paused||hover||reduce.matches||document.hidden)return;
      index=(index+1)%items.length;
      show();
      timer=setTimeout(step,3600);
    }
    function show(){items.forEach((el,i)=>{el.classList.toggle('is-motion-leaving',el.classList.contains('is-motion-active')&&i!==index);el.classList.toggle('is-motion-active',i===index);});}
    function sync(){
      clear();root.classList.toggle('motion-paused',paused||hover||!visible||reduce.matches||document.hidden);
      if(mobile.matches&&visible&&!paused&&!hover&&!reduce.matches&&!document.hidden)timer=setTimeout(step,index<0?100:1800);
    }
    // Keyboard focus or pointer hover holds the current information for reading.
    track.addEventListener('focusin',()=>{paused=true;sync();});
    track.addEventListener('focusout',e=>{if(!track.contains(e.relatedTarget)){paused=false;sync();}});
    track.addEventListener('keydown',e=>{if(!mobile.matches)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();const linkFocus=e.target.closest('a');index=(Math.max(0,index)+(e.key==='ArrowRight'?1:-1)+items.length)%items.length;show();if(linkFocus){track.focus({preventScroll:true});requestAnimationFrame(()=>requestAnimationFrame(()=>{items[index].querySelector('a').focus({preventScroll:true});}));}}else if(e.key===' '&&e.target===track){e.preventDefault();paused=!paused;sync();}});
    track.addEventListener('click',e=>{if(!e.target.closest('a')){paused=!paused;sync();}});
    root.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches){hover=true;sync();}});
    root.addEventListener('mouseleave',()=>{hover=false;sync();});
    index=0;show();
    new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.3}).observe(root);
    document.addEventListener('visibilitychange',sync);reduce.addEventListener('change',sync);mobile.addEventListener('change',sync);sync();
    document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root))clear();});
  }
  function boot(){document.querySelectorAll('[data-benefits-motion]').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
